import { MutationTree } from "vuex";
import { YearmonthsState, SET_YEARMONTHS } from "./types";

export const mutations: MutationTree<YearmonthsState> = {
  [SET_YEARMONTHS](state, yearmonths: string[]) {
    state.yearmonths = yearmonths;
  }
};
